export default function getNodeName(_0x2185c5){return _0x2185c5?(_0x2185c5['nodeName']||'')['toLowerCase']():null;}